/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import convertOperator from 'cio/utils/operators/convert';
import serializeEventAttribute from 'cio/utils/conditions/serialize/event-attribute';
import flattenArray from 'cio/utils/flatten-array';

const ERROR_KEY_LABELS = {
  operator: 'operator',
  value: 'value',
  value2: 'second value',
  name: 'name',
  timestampValue: 'timestamp',
};

export default class EventAttribute extends BaseEditorComponent {
  // external API
  condition = null;
  campaign = null;
  disabled = false;
  allowComparisonOperator = false;
  allowJsonOperators = false;
  showEventNameInEditor = true;
  onApply() {}

  get size() {
    return null;
  }
  variation = null;
  subLayout = null;

  // internal state
  @action
  _onApply() {
    let condition = serializeEventAttribute(this.condition, false, true, this.allowComparisonOperator);
    condition.operator = convertOperator(condition.operator);

    return this.onApply(condition);
  }

  @computed('condition.errors')
  get errors() {
    let conditionErrors = this.condition.errors || {};
    return flattenArray(
      Object.keys(conditionErrors).map((key) => {
        let errors = conditionErrors[key];

        return errors.map((err) => `${ERROR_KEY_LABELS[key]} ${err}`);
      }),
    );
  }
}
